import React from 'react';
import { IconSvgProps } from '@models/common';

const FactChecker: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.76562 15.4997V4.49969C1.76571 3.77489 2.05388 3.0796 2.56641 2.56708C3.07893 2.05455 3.77422 1.76638 4.49902 1.7663H13.499C15.1006 1.7663 16.3994 3.06506 16.3994 4.66669V9.24969C16.3994 9.74675 15.9961 10.1501 15.499 10.1501C15.0021 10.1499 14.5996 9.74664 14.5996 9.24969V4.66669C14.5996 4.05917 14.1065 3.56708 13.499 3.56708H12.9268V7.15497C12.9268 7.48327 12.7477 7.78589 12.46 7.94403C12.1725 8.10189 11.8219 8.0913 11.5449 7.91571L10.0156 6.94501L8.46875 7.91766C8.19141 8.09178 7.84129 8.10149 7.55469 7.94305C7.26808 7.78459 7.08984 7.48247 7.08984 7.15497V3.56708H4.49902C4.25161 3.56716 4.0148 3.66556 3.83984 3.84052C3.66489 4.01547 3.56649 4.25228 3.56641 4.49969V15.4997C3.56641 15.7472 3.66481 15.9848 3.83984 16.1599C4.01479 16.3347 4.25168 16.4332 4.49902 16.4333H7.83301C8.32991 16.4335 8.73242 16.8367 8.73242 17.3337C8.73225 17.8305 8.32981 18.2329 7.83301 18.2331H4.49902C3.77422 18.233 3.07893 17.9448 2.56641 17.4323C2.05401 16.9197 1.76563 16.2245 1.76562 15.4997ZM8.89062 5.52704L9.54102 5.11884L9.6543 5.05829C9.92681 4.93733 10.2455 4.95801 10.502 5.12079L11.127 5.51727V3.56708H8.89062V5.52704Z'
        fill='currentColor'
      />
      <path
        d='M1.76562 15.4997C1.76571 14.7749 2.05388 14.0796 2.56641 13.5671C3.07893 13.0546 3.77422 12.7664 4.49902 12.7663H7.95215C8.4492 12.7663 8.85254 13.1696 8.85254 13.6667C8.85254 14.1637 8.4492 14.5671 7.95215 14.5671H4.49902C4.25161 14.5672 4.0148 14.6656 3.83984 14.8405C3.66489 15.0155 3.56649 15.2523 3.56641 15.4997C3.56641 15.9968 3.16307 16.4001 2.66602 16.4001C2.16896 16.4001 1.76562 15.9968 1.76562 15.4997Z'
        fill='currentColor'
      />
      <path
        d='M17.0028 12.2415C17.3993 11.8571 18.0324 11.8666 18.4169 12.263C18.8013 12.6594 18.7918 13.2926 18.3954 13.6771L13.5741 18.3519L11.0028 15.8587C10.6066 15.4742 10.5969 14.8411 10.9813 14.4446C11.3658 14.0484 11.999 14.0388 12.3954 14.4232L13.5741 15.5657L17.0028 12.2415Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default FactChecker;
